import { Pipe, PipeTransform } from '@angular/core';
import { Province, provinceLabel } from '@macs-frontend/features/shared/models/province';

/**
 * Renders a province code as its English display name ('EAST_FLANDERS' →
 * 'East Flanders'). A null province renders as the empty string, so a template
 * can lean on `*ngIf` over the raw value rather than over the label.
 *
 * Takes a bare string as well as the shared enum: the GraphQL codegen emits its
 * own `Province` enum, and TypeScript treats two string enums with identical
 * members as unrelated types.
 */
@Pipe({ name: 'provinceLabel' })
export class ProvinceLabelPipe implements PipeTransform {
  public transform(province?: Province | string | null): string {
    return provinceLabel(province as Province | null | undefined);
  }
}
